import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { makeStyles } from "@mui/styles";
import {MoneyFormatv3 } from "../../../library/MoneyFormat";
import { useSelector } from "react-redux";
import { useStateList } from "./HandleInvoiceStateProvider";
const useStyles = makeStyles({
  table: {
    "& .MuiTableCell-root": {
      border: "1px solid rgba(224, 224, 224, 1)",
    },
  },
});
function HsnAndTaxTable({
  data,
  items,
  nonItems,
  companyState,
  totTaxAmt,
  totNetAmt,
  totGST,
  Type,
  partyType,
  registrationType,
}) {
  const headCell = [
    {
      id: "Hsn",
      label: "HSN/SAC",
      width: 100,
      currency: "",
    },
    {
      id: "gstRate",
      //LEDX-4673
      label: registrationType === 3  && partyType==="CUSTOMER"? "Composition Rate (%)" : "GST Rate (%)",
      width: 80,
      currency: "",
    },
    {
      id: "taxableValue",
      label: "Taxable Value",
      width: 120,
      currency: data?.currency?.sign,
    },

    {
      id: "igst",
      label: "IGST",
      width: 80,
      currency: data?.currency?.sign,
    },
    {
      id: "cgst",
      label: "CGST",
      width: 80,
      currency: data?.currency?.sign,
    },
    {
      id: "sgst",
      label: "SGST",
      width: 80,
      currency: data?.currency?.sign,
    },
    {
      id: "total",
      label: "Total",
      width: 80,
      currency: data?.currency?.sign,
    },
  ];
  let getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
  let EInvoiceFlag = getCompany?.relatedcompanydetailsnew?.[0]?.einvoiceflag;
  const {viewMode}=useStateList()
  const [hsnArr, setHsnArr] = useState([]);
  const [totalSummaryAmt, setTotalSummaryAmount] = useState(0);
  const [totalSumTaxAmt, setTotalSumTaxAmt] = useState(0);
  const [totIGSTAmt, setTotIGSTAmt] = useState(0);
  const [totCGSTAmt, setTotCGSTAmt] = useState(0);
  const [totSGSTAmt, setTotSGSTAmt] = useState(0);
  const classes = useStyles();
  function displayHsnSummary() {
    let itemObj = {};
    let nonItemObj = {};
    let nonItemHsnArr = [];
    let itemHSnArr = [];
    items.map((ele) => {
      if (ele?.itemCode?.label !== "") {
        itemObj = {
          hsnID: ele.HSN?.value,
          gstRate: [2, 3, 5, 7, 9].includes(
            Number(data?.taxability?.value))?0:(Number(ele?.GSTRate)>0? ele.GSTRate:0),
          taxAmt:
            data.reverseChargeFlag === 0
              ? Number(ele.taxableAMount)
              : 
              // Type !== "Purchase"
              (Type==="Pos" || partyType==="CUSTOMER")
              ? 
              0    
              : Number(ele.taxableAMount),
          IGST:
          //LEDX-4673
            registrationType === 3 && partyType==="CUSTOMER"
              ? 0.0
              : data.placeOfSupply.value !== companyState
              ? Number(ele.IGST)
              :((
                // EInvoiceFlag &&
                //  partyType==="CUSTOMER" &&
                  data?.partyCategory==="SEZ")? Number(ele.IGST): 0.0),
          CGST:
          //LEDX-4673
            registrationType === 3 && partyType==="CUSTOMER"
              ? 0.0
              : data.placeOfSupply.value == companyState
              ? ((
                // EInvoiceFlag && 
                // partyType==="CUSTOMER" && 
                data?.partyCategory==="SEZ")?0.0:Number(ele.IGST) / 2)
              : 0.0,
          SGST:
          //LEDX-4673
            registrationType === 3 && partyType==="CUSTOMER"
              ? 0.0
              : data.placeOfSupply.value == companyState
              ? ((
                // EInvoiceFlag && 
                // partyType==="CUSTOMER" && 
                data?.partyCategory==="SEZ")?0.0:(Number(ele.IGST) / 2))
              : 0.0,
          GSTCess: registrationType === 3 && partyType==="CUSTOMER"? 0.0 : ele.GSTCess, //LEDX-4673
          total:
            registrationType === 3  && partyType==="CUSTOMER" //LEDX-4673
              ? Number(ele.taxableAMount)
              : data.reverseChargeFlag == 0
              ? Number(ele.taxableAMount) + Number(ele.IGST)
              : Number(ele.IGST),
        };
        itemHSnArr.push(itemObj);
      }
    });
    nonItems.map((ele) => {
      if (ele?.ledgerAccount?.label !== "") {
        nonItemObj = {
          hsnID: ele?.HSN?.value,
          gstRate: [2, 3, 5, 7, 9].includes(
            Number(data?.taxability?.value))?0:(Number(ele?.GSTRate)>0? ele.GSTRate:0),
          taxAmt:
            data.reverseChargeFlag === 0
              ? Number(ele.taxableAMount)
              :
              //  Type !== "Purchase"
              (Type==="Pos" || partyType==="CUSTOMER")
               ?
               0
              : Number(ele.taxableAMount),
          IGST:
            registrationType === 3 && partyType==="CUSTOMER" //LEDX-4673
              ? 0.0
              : data.placeOfSupply.value !== companyState
              ? Number(ele.IGST)
              : ((
                // EInvoiceFlag && 
                // partyType==="CUSTOMER" &&
                 data?.partyCategory==="SEZ")?Number(ele.IGST):0.0),
          CGST:
            registrationType === 3 && partyType==="CUSTOMER" //LEDX-4673
              ? 0.0
              : data.placeOfSupply.value == companyState
              ? ((
                // EInvoiceFlag && 
                // partyType==="CUSTOMER" && 
                data?.partyCategory==="SEZ")?0.0:Number(ele.IGST) / 2)
              : 0.0,
          SGST:
            registrationType === 3 && partyType==="CUSTOMER" //LEDX-4673
              ? 0.0
              : data.placeOfSupply.value == companyState
              ?((
                // EInvoiceFlag && 
                // partyType==="CUSTOMER" &&
                 data?.partyCategory==="SEZ")?0.0:Number(ele.IGST) / 2)
              : 0.0,
          GSTCess: registrationType === 3 && partyType==="CUSTOMER"? 0.0 : ele.GSTCess, //LEDX-4673
          total:
          //LEDX-4673
            registrationType === 3 && partyType==="CUSTOMER"   //LEDX-4673
              ? Number(ele.taxableAMount)
              : data.reverseChargeFlag == 0
              ? Number(ele.taxableAMount) + Number(ele.IGST)
              : Number(ele.IGST),
        };
        nonItemHsnArr.push(nonItemObj);
      }
    });
    let combinedArr = [...itemHSnArr, ...nonItemHsnArr];
    // let filteredArr = combinedArr.filter(item => item.hsnID !== "");
    let totSumAmt = 0;
    let totTaxSumAmt = 0;
    let totIGST = 0;
    let totSGST = 0;
    let totCGST = 0;
    combinedArr.map((ele) => {
      totSumAmt += Number(ele.total);
      totTaxSumAmt += Number(ele.taxAmt);
      totCGST += Number(ele.CGST);
      totIGST += Number(ele.IGST);
      totSGST += Number(ele.SGST);
    });
    setTotCGSTAmt(totCGST);
    setTotIGSTAmt(totIGST);
    setTotSGSTAmt(totSGST);
    setTotalSumTaxAmt(totTaxSumAmt);
    setTotalSummaryAmount(totSumAmt);
    const uniqueIds = [];
    let tempArray = [];
    const unique = combinedArr.filter((element) => {
      const isDuplicate =
        uniqueIds.includes(element.hsnID) &&
        uniqueIds.includes(element.gstRate);
      if (!isDuplicate) {
        uniqueIds.push(element.hsnID, element.gstRate);
        tempArray.push({
          taxAmt: element.taxAmt,
          IGST: element.IGST,
          CGST: element.CGST,
          SGST: element.SGST,
          gstRate: element.gstRate,
          hsnID: element.hsnID,
          total: element.total,
        });
        return true;
      } else {
        tempArray.map((item) => {
          if (element.hsnID == item.hsnID && item.gstRate == element.gstRate) {
            item.taxAmt += Number(element.taxAmt);
            item.IGST += Number(element.IGST);
            item.CGST += Number(element.CGST);
            item.SGST += element.SGST;
            // item.gstRate+=element.gstRate
            item.total += element.total;
          }
        });
      }
      return false;
    });
    setHsnArr(tempArray);
  }
  useEffect(() => {
    displayHsnSummary();
  }, [items, nonItems, data,partyType]);
  return (
    <Box sx={{ m: 1 }}>
      <Box
        >
        <TableContainer
          sx={{
            ".MuiTableContainer-root": {
              overflowY: "scroll",
              overflowX: "none",
            },
            maxHeight: 200,
          }}
        >
          <Table
            stickyHeader
            className={classes.table}
            aria-label="simple table"
          >
            <TableHead sx={{ color: "#FFF" }}>
              <TableRow>
                {headCell.map((column, ind) => {
                  if (column.currency !== "") {
                    column.currency = data.currency.sign;
                  }
                  return (
                    <TableCell
                      key={ind}
                      width={column.width}
                      sx={{
                        fontWeight: 600,
                        fontSize: "12px",
                        color: "input.label",
                        backgroundColor: "background.tablebg",
                        padding: "8px",
                        textAlign:"center"
                      }}
                    >
                      <span>{column.label} </span>
                      {column.currency !== "" ? (
                        <span>({column.currency})</span>
                      ) : (
                        ""
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody
            className={viewMode === true ? "disable-interactions !mportant" : ""}>
              {hsnArr.map((ele) => {
                return (
                  <TableRow >
                    <TableCell>
                      {ele.hsnID === "" ? "No data" : ele.hsnID}
                    </TableCell>
                    <TableCell align="right">{ele.gstRate}</TableCell>
                    <TableCell align="right">{MoneyFormatv3(Number(ele.taxAmt))}</TableCell>

                    <TableCell align="right">{MoneyFormatv3(Number(ele.IGST))}</TableCell>
                    <TableCell align="right">{MoneyFormatv3(Number(ele.CGST))}</TableCell>
                    <TableCell align="right">{MoneyFormatv3(Number(ele.SGST))}</TableCell>
                    <TableCell align="right">{MoneyFormatv3(Number(ele.total))}</TableCell>
                  </TableRow>
                );
              })}
              {totalSummaryAmt !== 0 && (
                <TableRow>
                  <TableCell align="left" sx={{ fontWeight: 600 }}>Total (₹)</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 600 }}></TableCell>
                  <TableCell align="right" sx={{ fontWeight: 600 }}>
                    {MoneyFormatv3(Number(totalSumTaxAmt))}
                  </TableCell>

                  <TableCell align="right" sx={{ fontWeight: 600 }}>
                    {MoneyFormatv3(Number(totIGSTAmt))}
                  </TableCell>
                  <TableCell align="right" sx={{ fontWeight: 600 }}>
                    {MoneyFormatv3(Number(totCGSTAmt))}
                  </TableCell>
                  <TableCell align="right" sx={{ fontWeight: 600 }}>
                    {MoneyFormatv3(Number(totSGSTAmt))}
                  </TableCell>
                  <TableCell align="right" sx={{ fontWeight: 600 }}>
                    {MoneyFormatv3(Number(totalSummaryAmt))}
                  </TableCell>
                </TableRow>
              )}
              {data.reverseChargeFlag === 1 && (Type ==="Pos" || partyType==="CUSTOMER") && (
                <TableRow>
                  <TableCell colSpan={7} sx={{ fontWeight: 600 }}>
                    Rs.{MoneyFormatv3(Number(totalSummaryAmt))} of GST to be
                    paid by you as reverse charge basis
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}

export default HsnAndTaxTable;
